import AuthenticationService from "../Services/AuthenticationService"

export const logIn = (val) => dispatch => {
    AuthenticationService.logIn();
}

export const setLoggedIn = (value) => ({
    type: 'SET_LOGGED_IN',
    payload: value
})